<template>
  <div
    class="con"
    :style="{
      marginTop: mt,
    }"
  >
    <div class="cards-container text-center slider">
      <!-- Left Button -->
      <!-- <button class="control-btn left" @click="moveLeft">←</button> -->
      <div
        class="slider-track cards"
        :style="{
          // width: `${data.length * 250}px`,
          '--length': `${data.length}`,
          '--time': `${data.length * 4}s`,
        }"
      >
        <div
          class="card w-100 slide"
          v-for="item in data"
          :key="item?.course_id"
        >
          <img
            class="card-img w-100 h-100"
            :src="item?.cover"
            :alt="item?.name"
          />
          <div class="footer">
            <h2>
              {{ item?.name }}
            </h2>
            <p>{{ item?.price }} جنية</p>
            <div
              class="bottom"
              :class="{
                'd-flex justify-content-between': !item?.has_subscription,
                'd-flex justify-content-center': item?.has_subscription,
              }"
            >
              <router-link
                class="subscribe-btn"
                :to="{
                  name: 'payment',
                  params: { id: item?.course_id },
                  query: { free: item?.free },
                }"
                v-if="!item?.has_subscription"
                >اشترك الان</router-link
              >
              <button class="cart-btn" v-if="!item?.has_subscription">
                <ClShoppingBag01 />
              </button>
              <router-link
                class="subscribe-btn"
                :to="{
                  name: 'course_content',
                  params: { id: item?.course_id },
                }"
                v-else
              >
                الدخول للكورس
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Right Button -->
      <!-- <button class="control-btn right" @click="moveRight">→</button> -->
    </div>
  </div>
</template>

<script>
import { ClShoppingBag01 } from "@kalimahapps/vue-icons";

export default {
  name: "CourseCardsComponent",
  components: {
    ClShoppingBag01,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    mt: {
      type: String,
      default: "0",
    },
  },
  methods: {
    duplicatedItems() {
      const carousel = document.querySelector(".slider .slider-track");
      const carouselItems = Array.from(carousel.children);
      carouselItems.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        carousel.appendChild(duplicatedItem);
      });
    },
    // moveRight() {
    //   const carousel = document.querySelector(".slider .slider-track");
    //   const currentTransform = getComputedStyle(carousel).transform;
    //   let currentX =
    //     currentTransform !== "none"
    //       ? parseFloat(currentTransform.split(",")[4])
    //       : 0;
    //   const newX = currentX - 250;
    //   carousel.style.transform = `translateX(${newX}px)`;
    // },
    // moveLeft() {
    //   const carousel = document.querySelector(".slider .slider-track");
    //   const currentTransform = getComputedStyle(carousel).transform;
    //   let currentX =
    //     currentTransform !== "none"
    //       ? parseFloat(currentTransform.split(",")[4])
    //       : 0;
    //   const newX = currentX + 250;
    //   carousel.style.transform = `translateX(${newX}px)`;
    // },
  },
  mounted() {
    if (this.data.length > 0) {
      this.duplicatedItems();
    }
  },
};
</script>

<style scoped>
/* Controls */
.control-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #000;
  color: #fff;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  z-index: 10;
  padding: 0.5rem 1rem;
  border-radius: 50%;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}
.control-btn:hover {
  opacity: 1;
}
.control-btn.left {
  left: 10px;
}
.control-btn.right {
  right: 10px;
}

/* ===================== */
.con {
  padding: 0 1rem;
}
.con h2 {
  color: #dad2c5;
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.slider {
  margin: auto;
  display: grid;
  place-items: center;
  position: relative;
  width: 100%;
  overflow: hidden;
}
.slider-track {
  display: flex;
  gap: 0.5rem;
  animation: move var(--time) linear infinite;
  transition: transform 0.3s ease;
}
.slider:hover .slider-track {
  animation-play-state: paused;
}
@keyframes move {
  to {
    transform: translateX(calc(50% - 0.25rem));
  }
}
.slide {
  height: 200px;
  width: 250px;
  width: calc(100% / var(--length) * 2) !important;
}
.cards-container .cards {
  margin: 0 auto;
  overflow: hidden;
}
.cards-container .cards .card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 1rem;
  min-width: 350px;
  /* width: calc(100% / var(--length)) !important; */
  width: 100%;
  min-height: 475px;
  padding: 0;
  background: transparent;
  overflow: hidden;
  position: relative;
  border: 0;
}
.cards-container .cards .card .card-img {
  height: 475px !important;
  border-radius: 1rem;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.footer {
  position: absolute;
  bottom: -100%;
  background-color: #00000066;
  width: 100%;
  /* height: 40%; */
  backdrop-filter: blur(50px);
  transition: bottom 0.3s;
  padding: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
}
.cards-container .cards .card:hover .footer {
  bottom: 0;
  transition: bottom 0.3s;
}
.cards-container .cards .card .footer h2 {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.cards-container .cards .card .footer p {
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.cards-container .cards .card .footer .bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
}
.cards-container .cards .card .footer .bottom .subscribe-btn {
  background-color: #2b4239;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  width: calc(100% - 30px - 0.5rem);
  min-height: 40px;
  transition: all 0.3s ease-in-out;
}
.cards-container .cards .card .footer .bottom .subscribe-btn:hover {
  background-color: #dad2c5;
  color: #0d0d0d;
  transition: all 0.3s ease-in-out;
}
.cards-container .cards .card .footer .bottom .cart-btn {
  background-color: #fdfac4;
  color: #000000;
  border-radius: 0.5rem;
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
  font-weight: 700;
  border: none;
  transition: all 0.3s ease-in-out;
}
.cards-container .cards .card .footer .bottom .cart-btn:hover {
  background-color: #dad2c5;
  transition: all 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .con {
    margin-top: 0;
  }
  .swiper-slide {
    width: calc(100% / 3) !important;
    min-width: calc(100% / 3) !important;
    max-width: calc(100% / 3) !important;
  }
}
@media (max-width: 768px) {
  .swiper-slide {
    width: 50% !important;
    min-width: 50% !important;
    max-width: 50% !important;
  }
}
@media (max-width: 568px) {
  .swiper-slide {
    width: 50% !important;
    min-width: 50% !important;
    max-width: 50% !important;
  }
  .cards-container .cards .card .footer h2 {
    font-size: 1rem;
  }
  .cards-container .cards .card .footer p {
    font-size: 0.75rem;
  }
  .cards-container .cards .card {
    min-width: 200px;
  }
}
</style>
